



































































import { JobReference } from '../../interfaces/JobReference'
import { JobTree } from '../../types/JobTree'
import { GroupedJobs, TreeItem } from '../../types/TreeItem'
import { Job } from '@rundeck/client/dist/lib/models'
import Vue from 'vue'
import ProjectPicker from './ProjectPicker.vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { client } from '../../modules/rundeckClient'

Vue.component("project-picker",ProjectPicker)

@Component
export default class JobConfigPicker extends Vue {
  @Prop({ required: false, default: '' })
  value!: string
  @Prop({ required: false, default: '' })
  size!: string
  @Prop({ required: false, default: "" })
  btnType!: string
  @Prop({ required: false, default: "" })
  btnSize!: string
  @Prop({ required: false, default: "" })
  btnClass!: string
  @Prop({required:false,default:true})
  showScheduledToggle!:boolean
  @Prop({required:false,default:false})
  showScheduledDefault!:boolean

  selectedJob: JobReference | null = null
  modalOpen: boolean = false
  jobs: Job[] = []
  jobTree: JobTree = new JobTree()
  project: string = ''
  showProjectSelector: boolean = true
  filterType: string = this.showScheduledDefault?'scheduled':''

@Watch('project')
@Watch('filterType')
  loadJobs() {
    if(this.project != '') {
      let params:{[name: string ] : any} = {}

      if(this.filterType!=''){
        params['scheduledFilter']=(this.filterType==='scheduled')
      }

      client.jobList(this.project,params ).then(result => {
        this.$set(this,'jobTree', new JobTree())
        this.$set(this,'jobs', result)
        this.jobs.forEach(job => this.jobTree.insert(job))
      })
    }
  }

  @Watch('selectedJob')
  jobChosen() {
    this.modalOpen = false
    this.$emit('input', this.selectedJob ? this.selectedJob.id : '')
  }

  mounted() {
    if(window._rundeck.projectName) {
      this.showProjectSelector = false
      this.project = window._rundeck.projectName
    }
  }
}
